import React from 'react';
import eliteSsLeft1New from '../../assests/images/venkatadri-gardens.jpg';
import eliteSsLeft4New from '../../assests/images/b-v-r-bobba-venkateswara-rao-convention-hall.jpg';
import eliteSsLeft5New from '../../assests/images/gsp-convention-ac-function-hall.jpg';
import eliteSsLeft6New from '../../assests/images/sri-uma-ramalingeswara-swamy-vari-kalyana-mandapam.jpg';

function MahalAds() {
    const mahalAds = [
        { id: 1, image: eliteSsLeft4New, names: 'VS Classic' },
        { id: 2, image: eliteSsLeft1New, names: 'Venkateswara Kalyana Mandapam' },
        // { id: 4, image: eliteSsLeft5New, names: 'GSP Convention Hall' },
        { id: 3, image: eliteSsLeft6New, names: 'Rajeswarao Mandapam' },
    ];

    const scrollItems = [...mahalAds, ...mahalAds];

    return (
        <section className="success-stories" style={{ background: '#f9f9f9', padding: '40px 0', overflow: 'hidden' }}>
            <style>
                {`
                @keyframes scroll {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-50%); }
                }

                .scroll-container {
                    display: flex;
                    /* Total width must match the number of items * item width */
                    width: calc(400px * ${scrollItems.length}); 
                    animation: scroll 25s linear infinite;
                }

                .scroll-container:hover {
                    animation-play-state: paused;
                }

                .mahal-card {
                    width: 400px;
                    flex-shrink: 0;
                    padding: 10px;
                    position: relative; /* Essential for absolute positioning of the text */
                }

                .image-container {
                    position: relative;
                    overflow: hidden;
                    border-radius: 8px;
                    height: 250px;
                }

                .venue-name-overlay {
                    position: absolute;
                    bottom: 10px;
                    right: 15px;
                    background: rgba(0, 0, 0, 0.6); /* Semi-transparent background for readability */
                    color: white;
                    padding: 5px 15px;
                    border-radius: 4px;
                    font-family: 'Satisfy', cursive;
                    font-size: 2.5rem;
                    margin: 0;
                    pointer-events: none; /* Allows mouse hover to pass through to the container */
                }
                `}
            </style>

            <div className="container-fluid">
                <div className="row">
                    {/* <h2 className="text-center font-great-vibes mb-4">VS Classic</h2> */}
                </div>

                <div className="infinite-slider-wrapper" style={{ overflow: 'hidden' }}>
                    <div className="scroll-container">
                        {scrollItems.map((story, index) => (
                            <div key={`${story.id}-${index}`} className="mahal-card">
                                <div className="image-container">
                                    <img
                                        src={story.image}
                                        alt={story.names}
                                        style={{
                                            height: "100%",
                                            width: "100%",
                                            objectFit: "cover",
                                            display: 'block'
                                        }}
                                    />
                                    <h3 className="venue-name-overlay">
                                        {story.names}
                                    </h3>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div class="col-md-8 col-12 mx-auto pt-3 xs-small-text1 box-min-width-text1" style={{ fontFamily: 'Poppins' }}>
                    <span style={{ fontSize: "24px" }}>
                        <strong>
                            Our Ads
                        </strong>
                    </span>
                </div>
            </div>
        </section>
    );
}

export default MahalAds;